// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { GenericDocsListComponent } from './pages/generic-docs-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: GenericDocsListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: []
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class GenericDocsRoutingModule { }
